import { render, staticRenderFns } from "./selected-attendees-header.vue?vue&type=template&id=4feefa2c&scoped=true"
import script from "./selected-attendees-header.vue?vue&type=script&lang=js"
export * from "./selected-attendees-header.vue?vue&type=script&lang=js"
import style0 from "./selected-attendees-header.vue?vue&type=style&index=0&id=4feefa2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feefa2c",
  null
  
)

export default component.exports